var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoad01 = function SvgRoad01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "road-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#road-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.999 12a11.99 11.99 0 0 1-5.984 10.384l-.022.013A11.922 11.922 0 0 1 12 24a11.893 11.893 0 0 1-5.972-1.591l-.021-.012A11.994 11.994 0 0 1 0 11.999C0 7.556 2.415 3.675 6.005 1.603l.021-.012A11.934 11.934 0 0 1 12 0a11.964 11.964 0 0 1 6.017 1.616A11.992 11.992 0 0 1 24 12h-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.503a8.469 8.469 0 0 0-6 2.48v12.033a8.474 8.474 0 0 0 6 2.48 8.472 8.472 0 0 0 6-2.48V5.983a8.465 8.465 0 0 0-6-2.48Zm.3 15.899h-.6V17.38h.6v2.022Zm0-4.261h-.6v-2.022h.6v2.022Zm0-4.261h-.6V8.858h.6v2.022Zm0-4.261h-.6V4.597h.6v2.022Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "road-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgRoad01 as ReactComponent };